import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const gradeProgressionApi = axios.create({
  baseURL: `${API_BASE_URL}/grade-progression`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
gradeProgressionApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
gradeProgressionApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const gradeProgressionService = {
  getGradeProgression: (employeeId) => 
    gradeProgressionApi.get(`/employees/${employeeId}`),
  
  getEligibleEmployees: () => 
    gradeProgressionApi.get('/eligible'),
  
  promoteEmployee: (employeeId) => 
    gradeProgressionApi.put(`/employees/${employeeId}/promote`),
  
  promoteAllEligible: () => 
    gradeProgressionApi.post('/promote-all'),
};

export default gradeProgressionService;

